<template>
    <div v-if="data" class="w-full flex flex-column gap-2 xl:gap-3 lg:gap-3 md:gap-3">
        <div class="w-full flex flex-column xl:flex-row lg:flex-row md:flex-row
            gap-2 xl:gap-3 lg:gap-3 md:gap-3">
            <div class="w-full flex flex-1 flex-row gap-2 xl:gap-3 lg:gap-3 md:gap-3">
                <div v-if="data && data.amount" class="w-full flex flex-column flex-1 surface-50 
                    p-3 xl:p-4 lg:p-4 md:p-4
                    border-round-lg xl:border-round-2xl lg:border-round-2xl md:border-round-xl
                    text-left">
                    <span class="flex text-600 mb-2 text-xs xl:text-sm lg:text-sm md:text-sm">
                        Сумма переводов:
                    </span>
                    <span  v-if="data.amount" class="flex text-700 font-medium white-space-nowrap text-lg xl:text-xl lg:text-lg md:text-lg">
                        {{ get_format_amount(data.amount, 'usdt') }}
                    </span>
                </div>
                <div v-if="data && data.earned"
                    class="w-full flex flex-column flex-1 surface-50 
                    p-3 xl:p-4 lg:p-4 md:p-4
                    border-round-lg xl:border-round-2xl lg:border-round-2xl md:border-round-xl
                    text-left">
                    <span class="flex text-600 mb-2 text-xs xl:text-sm lg:text-sm md:text-sm">
                        Заработано за период:
                    </span>
                    <span class="flex text-700 font-medium white-space-nowrap text-lg xl:text-xl lg:text-lg md:text-lg">
                        {{ get_format_amount(data.earned, 'usd') }}
                    </span>
                </div>
            </div>
            <div v-if="data && data.stat && (data.stat.count != null && data.stat.count != undefined) &&
                (data.stat.time != null && data.stat.time != undefined)"
                class="w-full flex flex-column flex-1 surface-50 
                p-3 xl:p-4 lg:p-4 md:p-4
                border-round-lg xl:border-round-2xl lg:border-round-2xl md:border-round-xl
                text-left">
                <span class="flex text-600 mb-2 text-xs xl:text-sm lg:text-sm md:text-sm">
                    Количество переводов:
                </span>
                <span class="flex text-700 font-medium mb-4 white-space-nowrap text-lg xl:text-xl lg:text-lg md:text-lg">
                    {{ data.stat.count }}
                </span>
                <span class="flex text-600 mb-2 text-xs xl:text-sm lg:text-sm md:text-sm">
                    Среднее время перевода:
                </span>
                <span class="flex text-700 font-medium white-space-nowrap text-lg xl:text-xl lg:text-lg md:text-lg">
                    {{ formateTimer(data.stat.time) }}
                </span>
            </div>
        </div>

        <div class="w-full flex flex-row xl:flex-row lg:flex-row md:flex-row 
            gap-2 xl:gap-3 lg:gap-3 md:gap-3">
            <div v-if="data && data.active_from != undefined && data.active_to != undefined"
                class="w-full flex flex-column flex-1 surface-50 
                p-3 xl:p-4 lg:p-4 md:p-4
                border-round-lg xl:border-round-2xl lg:border-round-2xl md:border-round-xl
                text-left">
                <span class="flex text-600 mb-2 text-xs xl:text-sm lg:text-sm md:text-sm">
                    Время работы по МСК:
                </span>
                <span class="flex text-700 font-medium mb-4 white-space-nowrap text-md xl:text-xl lg:text-lg md:text-lg">
                    {{ get_msk_time(data.active_from) }} - {{ get_msk_time(data.active_to) }}
                </span>
                <span class="flex text-600 mb-2 text-xs xl:text-sm lg:text-sm md:text-sm">
                    Время работы по Бали:
                </span>
                <span class="flex text-700 font-medium white-space-nowrap text-md xl:text-xl lg:text-lg md:text-lg">
                    {{ get_local_time(data.active_from) }} - {{ get_local_time(data.active_to) }}
                </span>
            </div>
            <div v-if="data && data.active != undefined && data.online != undefined" 
                class="w-full flex flex-column flex-1 surface-50 
                p-3 xl:p-4 lg:p-4 md:p-4
                border-round-lg xl:border-round-2xl lg:border-round-2xl md:border-round-xl
                text-left">
                <span class="flex text-600 mb-2 text-xs xl:text-sm lg:text-sm md:text-sm">
                    Активность:
                </span>
                <span class="flex text-700 font-medium mb-4 white-space-nowrap text-md xl:text-xl lg:text-lg md:text-lg">
                    {{ (data.active) ? 'Да' : 'Нет' }}
                </span>
                <span class="flex text-600 mb-2 text-xs xl:text-sm lg:text-sm md:text-sm">
                    Рабочее время:
                </span>
                <span class="flex text-700 font-medium white-space-nowrap text-md xl:text-xl lg:text-lg md:text-lg">
                    {{ (data.online) ? 'Да' : 'Нет' }}
                </span>
            </div>
        </div>
    </div>
    <Skeleton v-else height="3rem" class="border-round-lg"/>
</template>

<script>
import Connect from '@/assets/js/Connect'
import Helper from '@/assets/js/Helper'

export default {
    props: ['data'],
    data() {
        return {

        }
    },
    methods: {
        formateTimer(seconds) {
            return this.helper.get_timer_from_seconds(seconds)
        },
        get_msk_time(data){
            let time = data + 3
            if(time>24){
                time = time - 24
            }
            return time+':00'
        },
        get_local_time(data){
            let time = data + 8
            if(time>24){
                time = time - 24
            }
            return time+':00'
        },
        get_format_amount(value, currency) {
            return this.helper.format_amount(value, currency)
        },
    },
    async beforeCreate(){
        this.connect = new Connect()
        this.helper = new Helper()
    },
}
</script>